import { useCallback, useState } from "react";

export default function useLoadingState() {
  const [loadingCount, setLoadingCount] = useState<number>(0);

  const setLoading = useCallback((isLoading: boolean) => {
    setLoadingCount((prev) => prev + (isLoading ? 1 : -1));
  }, []);

  const loading = loadingCount > 0;

  return {
    loading,
    setLoading,
  };
}
